import { css } from "styled-components";

export const datePicker = {
    defaultProps: {
        mergeCss: true,
        cssOverrides: {
            datePicker: css`
                .react-datetime-picker {
                    border-radius: 7px;
                }
            `,
        },
    },
};